import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getZeroInDecimal } from '../../routes/payment/new/components/kushki/utils/kushki';
import formatPrice from '../../utils/price/format-price';

type CurrencyPriceProps = {
    price: Price;
    showZeroInDecimal?: boolean;
};

const CurrencyPrice: FC<CurrencyPriceProps> = ({ price, showZeroInDecimal = false }) => {
    const currency = useSelector((state: RootState) => state.main.currency);
    const convertedPrice = Number(String(price).replace(',', '.').replace(' ', ''));

    const formattedPrice = formatPrice(
        showZeroInDecimal ? getZeroInDecimal(convertedPrice).toFixed(2) : convertedPrice
    );

    if (formattedPrice?.indexOf('NaN') > -1) {
        return null;
    }

    return (
        <>
            {formatPrice(showZeroInDecimal ? getZeroInDecimal(convertedPrice).toFixed(2) : convertedPrice)}{' '}
            {currency.symbol}
        </>
    );
};

export default CurrencyPrice;
